<script>
    import { db } from './firebase'
    import { fly } from 'svelte/transition'
    import { onDestroy, onMount } from 'svelte'
	import { autoresize } from 'svelte-textarea-autoresize'
	import DragDropList from 'svelte-dragdroplist'
	import Header from './Header.svelte'
    export let params = {}

	let formTitle = 'loading...'
	let submittedMessage = ''
	let currentQuestion = 0
	let totalQuestions = 1
	let responses = []
	let submitted = false
    let questions = []
	let unansweredQuestions = []
	let disallowSubmit
	let mobileUser
	let liveForm = false

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
  		// true for mobile device
  		mobileUser = true
		console.log(mobileUser)
	} else {
  		// false for not mobile device
  		mobileUser = false
		console.log(mobileUser)
	}

	let currentUser

	import { currentUserStore } from './stores'
	const unsubscribe = currentUserStore.subscribe(value => {
		currentUser = value
	})

    onMount(() => {
		getFormData()
	})
    onDestroy(() => {
		unsubscribe()
	})

    const getFormData = () => {
		db.collection('forms').doc(params.form).get().then((doc) => {
			if (doc.exists) {
				questions = doc.data().questions
				formTitle = doc.data().title
				submittedMessage = doc.data().submittedMessage
				totalQuestions = questions.length
				backgroundImageURL = doc.data().backgroundImageURL
				if (doc.data().liveForm == true) { liveForm = true }
				
			} else {
				console.log("No such document!")
			}
		}).catch((error) => {
			console.log(error)
		})
	}

    const submitResponse = () => {
		// Reset counters
		unansweredQuestions = []
		disallowSubmit = false

		// Loop through every question response
		for (var index = 0, len = questions.length; index < len; index++) {

			// Set question in response array to same as questions array, for ranking questions bound to questions array
			if (questions[index].type == 'rank-list') {
				responses[index] = questions[index].choiceOptions
			}

			// Check each question to see if has been answered
			if ((responses[index] === undefined || responses[index] === null) && !(questions[index].type == 'multiple-choice' || questions[index].type == 'multiple-choice-with-maximum')) {
				// Fill in any empty multiple choice questions so array isn't missing a value
				// if (questions[index].type != 'multiple-choice' || questions[index].type != 'multiple-choice-with-maximum') {
					disallowSubmit = true
					unansweredQuestions = [...unansweredQuestions, (index + 1)]
				// }
			}

			// Check for any responses longer than 500 charcaters
			else if (!(questions[index].type == 'multiple-choice' || questions[index].type == 'multiple-choice-with-maximum') && responses[index].length > 500) {
				disallowSubmit = true
				alert('Your answer to question ' + (index + 1) + ' is over 500 characters, it must be below.')
				
			}

			// Keeping firebase happy
			if (disallowSubmit === false) {
				// Convert any multiple choice arrays to comma-seperated strings
				if (Array.isArray(responses[index])) {
					responses[index] = responses[index].join(',')
				}
				// Replace empty multiple choices with a value
				if ((responses[index] === undefined || responses[index] === null) && (questions[index].type != 'multiple-choice' || questions[index].type != 'multiple-choice-with-maximum')) {
					responses[index] = ''
				}
			}

		}
		console.log(disallowSubmit)

		if (disallowSubmit === false && unansweredQuestions.length === 0) {
			console.log('Form checks have passed.')
		} else {
			console.log('Form checks have failed.')
			alert('You have missed questions ' + unansweredQuestions)
		}

		console.log(responses)
		
		// Add the response to firebase if all checks pass
		if (disallowSubmit == false && unansweredQuestions.length === 0) {
			db.collection('responses').doc(currentUser.uid + '_' + params.form).set({
				form: params.form,
				responses: responses,
				timeSubmitted: Date.now(),
				user: currentUser.uid
			}).then(() => {
				submitted = true
			})
		}
	}
	const liveFormSubmitResponse = () => {
		db.collection("responses").doc(currentUser.uid + '_' + params.form).set({
			form: params.form,
			responses: responses,
			timeSubmitted: Date.now(),
			user: currentUser.uid
		})
		// 	}).then(() => {
		// 		submitted = true
		// })
	}
	const handleKeydown = event => {
		if (event.key == 'ArrowRight' && currentQuestion + 1 < totalQuestions) {
			currentQuestion++
		} else if (event.key == 'ArrowLeft' && currentQuestion > 0) {
			currentQuestion--
		}
	}
	const updateCheckboxResponse = (choice, event) => {
		// If the response array doesn't exist, create empty array to add to
		if (responses[currentQuestion] == undefined) {
			responses[currentQuestion] = []
		}
		// If array already contains value changed, remove it
		if (responses[currentQuestion].includes(choice)) {
			console.log(responses)
			responses[currentQuestion] = responses[currentQuestion].filter(value => {
				return value != choice
			})
		// Otherwise, add to the array
		} else if (responses[currentQuestion].length >= questions[currentQuestion].maximumSelections) {
			return false
		} else {
			responses[currentQuestion] = [...responses[currentQuestion], choice]
		}
	}

</script>

<svelte:window on:keydown={handleKeydown}/>

<!-- <Header title={formTitle}/> -->
<!-- Load questions once form data recieved -->
{#if questions.length > 0 && !submitted}
<div class="page">
    <div class="content">
        <p class="question-label"><span>{currentQuestion + 1}</span> / {totalQuestions}</p>
        <div class="question">
            {#key currentQuestion}
                <h1 in:fly="{{ y: -20, duration: 500 }}">{questions[currentQuestion].question}</h1>
            {/key}
            {#if questions[currentQuestion].type == 'single-choice'}
				<div class="choice-options">
                {#each questions[currentQuestion].choiceOptions as choice}
                    <label in:fly="{{ y: -20, duration: 500 }}">
                        <input type=radio bind:group={responses[currentQuestion]} value={choice}>
                        {choice}
                    </label>
                {/each}
				</div>
			{:else if questions[currentQuestion].type == 'multiple-choice'}
                {#each questions[currentQuestion].choiceOptions as choice}
                    <label in:fly="{{ y: -20, duration: 500 }}">
                        <input type=checkbox on:click|preventDefault={() => updateCheckboxResponse(choice)} class:checked={responses[currentQuestion] != undefined ? responses[currentQuestion].includes(choice) : false}>
                        {choice}
                    </label>
                {/each}
				<p class="label">You can select unlimited choices on this question.</p>
			{:else if questions[currentQuestion].type == 'multiple-choice-with-maximum'}
				{#each questions[currentQuestion].choiceOptions as choice}
				<label in:fly="{{ y: -20, duration: 500 }}">
					<input type=checkbox on:click|preventDefault={() => updateCheckboxResponse(choice)} class:checked={responses[currentQuestion] != undefined ? responses[currentQuestion].includes(choice) : false}>
					<!-- <input type=checkbox on:change={() => updateCheckboxResponse(choice)} checked={responses[currentQuestion] != undefined ? responses[currentQuestion].includes(choice) : false} disabled={((responses[currentQuestion] != undefined ? responses[currentQuestion].length : false) >= questions[currentQuestion].maximumSelections) && this.checked == false}> -->
					{choice}
				</label>
				{/each}
				<p class="label">You can select {questions[currentQuestion].maximumSelections} choices on this question.</p>
            {:else if questions[currentQuestion].type == 'short-text'}
                <input type="text" bind:value={responses[currentQuestion]} in:fly="{{ y: -20, duration: 500 }}" autofocus={!mobileUser}>
            <!-- {:else if questions[currentQuestion].type == 'number'}
                <input type="number" bind:value={responses[currentQuestion]} in:fly="{{ y: -20, duration: 500 }}"> -->
            {:else if questions[currentQuestion].type == 'long-text'}
				<textarea bind:value={responses[currentQuestion]} use:autoresize autofocus={!mobileUser} in:fly="{{ y: -20, duration: 500 }}"></textarea>
			{:else if questions[currentQuestion].type == 'slider-10'}
				<input type="range" min=1 max=10 bind:value={responses[currentQuestion]}>
				<p>{responses[currentQuestion] ? responses[currentQuestion] : 'move the slider'} <span class="label"> / 10</span></p>
			{:else if questions[currentQuestion].type == 'rank-list'}
				<DragDropList bind:data={questions[currentQuestion].choiceOptions}/>
				<p class="label">Drag the options to rank them (highest at the top).</p>
			{:else if questions[currentQuestion].type == 'live-4'}
                {#each questions[currentQuestion].choiceOptions as choice}
                    <label in:fly="{{ y: -20, duration: 500 }}" class="live-answer-button">
						<input type=radio bind:group={responses[currentQuestion]} value={choice} on:change={liveFormSubmitResponse}>{choice}
                    </label>
                {/each}
				<!-- {#each Array(10) as _, row}
					<label class="select-10" in:fly="{{ y: -20, duration: 500 }}">
						<input type=radio bind:group={responses[currentQuestion]} value={row + 1}>
						<p>{row + 1}</p>
					</label>
				{/each} -->
            {/if}
        </div>
    </div>
    <div class="buttons">
		{#if currentQuestion > 0 && currentQuestion < totalQuestions}	
			<button class="ghost" id="back-question-button" on:click={() => currentQuestion--}/>
		{/if}
        {#if currentQuestion + 1 < totalQuestions}
            <button class="cta" id="next-question-button" on:click={() => currentQuestion++}/>
        {:else if liveForm != true}
            <button class="cta" id="submit-button" on:click={submitResponse}/>
        {/if}
    </div>
</div>
{/if}
{#if submitted}
	<div class="content" in:fly="{{ y: -20, duration: 500 }}">
		<h1>Your response has been submitted.</h1>
		<p class="label">{submittedMessage}</p>
	</div>
{/if}
<!-- <div class="footer">
	<p>OKS Vote v1.5</p>
	<p class="name">Form Name</p>
	<p class="author">Made by Jude.</p>
	<p class="question-count">50 questions</p>
</div> -->

<style>
	.page {
		display: grid;
		/* grid-template: 100vh 145px / 100%; */
		grid-template: 98vh/ 1fr;
		height: 100%;
	}
	.content {
		grid-row: 1;
		grid-column: 1;
		align-self: center;
		margin: 4em 7% 4em;
	}
	.buttons {
		grid-row: 1;
		grid-column: 1;
		align-self: end;
		margin: 0 0 10vh 7%;
	}
	.question {
		margin-bottom: 120px;
	}
	.question p {
		margin-top: 0;
	}
    .question h1 {
		margin-bottom: 1em;
	}
	.question input {
		margin-top: 0;
	}
	.question input[type='text'] {
		width: 60%;
		min-width: 200px;
		max-width: 600px;
	}
	.question p.label {
		margin: 2em 0 0;
	}
	/* .choice-options {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
	} */
	#next-question-button, #back-question-button, #submit-button {
		background: none;
		background-image: url('/assets/arrow-right.svg');
		background-size: 20px;
		background-repeat: no-repeat;
		background-position: center;
		width: 55px;
		height: 55px;
		border-radius: 6px;
		float: right;
	}
	#next-question-button:hover, #back-question-button:hover, #submit-button:hover {
		background-color: var(--background-secondary);
		opacity: 1;
	}
	#back-question-button {
		transform: rotate(180deg);
		opacity: 0.2;
		float: left;
	}
	#submit-button {
		background-image: url('/assets/tick.svg');
	}
	.live-answer-button {
		padding: 26px;
		width: fit-content;
		min-width: 200px;
		display: inline-block;
		border-radius: 10px;
		margin-right: 10px;
	}
	.live-answer-button input {
		border-color: var(--content-secondary);
	}
	.live-answer-button:hover input {
		border-color: var(--content-primary);
	}
	.live-answer-button:nth-of-type(1) {
		background: #2073C7;
	}
	.live-answer-button:nth-of-type(2) {
		background: #204DC7;
	}
	.live-answer-button:nth-of-type(3) {
		background: #4020C7;
	}
	.live-answer-button:nth-of-type(4) {
		background: #6D20C7;
	}
	.buttons {
		width: 160px;
		grid-row: 1;
	}
	:global(.dragdroplist) {
		max-width: 600px;
	}
	:global(.dragdroplist > .list > div.item) {
		background: transparent;
		border: none;
		height: min-content;
		min-height: auto !important;
		margin-bottom: clamp(17px, 3vh, 30px);
	}
	:global(.dragdroplist p) {
		margin: 0;
	}
	:global(.dragdroplist #ghost) {
		background-color: var(--background-secondary) !important;
		border: none;
		border-radius: 6px;
	}
	:global(.dragdroplist div.content) {
		margin: 0 30px !important;
		user-select: none;
	}
	:global(.dragdroplist div.buttons) {
		/* fill: white;
		opacity: 0.3; */
		display: none !important;
	}
	@media only screen and (max-width: 600px) {
		.page {
			grid-template: 1fr / 100%;
		}
		.content {
			min-height: 90vh;
			height: fit-content;
			margin: 32px 5%;
		}
		#next-question-button:hover, #back-question-button:hover, #submit-button:hover {
			background-color: transparent !important;
		}
	}
</style>